import DataServiceSQL from "../../DataService/DataServiceSQL";
import DeviceFunctionsGetter from '../../Controller/getSQLDeviceFunctions.js';
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Row, Col } from 'reactstrap';
import { useTable } from "react-table";
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import AddDevice from './AddDevice.js';
import Device from './Device.js';
import DeleteObject from '../Common/DeleteObject.js';
import {FormattedMessage} from 'react-intl';
import { Icon } from 'semantic-ui-react';

const DeviceList = (props) => {
  const [device_list, setDeviceList] = useState([]);
  const [searchSerialNb, setSearchSerialNb] = useState("");
  const [display_Add_Device_Popup, setAddDevicePopup] = useState(false);
  const [display_Edit_Device_Popup, setEditDevicePopup] = useState(false); 
  const [display_Delete_Device_Popup, setDeleteDevicePopup] = useState(false);
  
  const [current_sn_Device, setCurrentDeviceSN] = useState("");  
  const [current_Id_Device, setCurrentDeviceID] = useState("");

  const deviceRef = useRef();

  deviceRef.current = device_list;

  useEffect(() => {
    retrieveDeviceList();
  }, 
  //eslint-disable-next-line
  []);

  const onChangeSearchSerialNb = (e) => {
    const searchSerialNb = e.target.value;
    setSearchSerialNb(searchSerialNb);
  };

  const retrieveDeviceList = async () => {
    let local_device_list = [];

    // get device list
    local_device_list = await DeviceFunctionsGetter.get_device_list(props.structure_Id);
    local_device_list = DeviceFunctionsGetter.convert_fhir_devices(local_device_list);
    if((local_device_list !== "none")&&(local_device_list !== undefined)&&(local_device_list.length !== 0)){ 
      let index_manual = local_device_list.findIndex(d => d.sn === "manual")
      if (index_manual !== -1) {
        local_device_list.splice(index_manual, 1)
      }
      setDeviceList(local_device_list);
      props.setDeviceList(local_device_list);
    }
    else{
      setDeviceList([]);
      props.setDeviceList([]);
    }
  };

  const findDeviceBySerialNb = () => {
    // TEMP: should be changed by getter function    
    if(searchSerialNb.length !== 0){
      DeviceFunctionsGetter.get_device_by_criteria("serialNumber", searchSerialNb)
      .then((response) => {
        setDeviceList(response);
        props.setDeviceList(response);
      })
      .catch((e) => {
        console.log(e);
      });
    }
    else{
      retrieveDeviceList();
    }
  };

  const editOrDeleteDevice = (rowIndex, action) => {
    //console.log("Edit Or Delete Device");
    let index_manual = deviceRef.current.findIndex(d => d.sn === "manual")
    if (index_manual !== -1) {
      deviceRef.current.splice(index_manual, 1)
    }
    setCurrentDeviceID(deviceRef.current[rowIndex].id_device)
    setCurrentDeviceSN(deviceRef.current[rowIndex].sn)

    if(action === "edit"){   
      manageEditDeviceDisplay()
    }
    else if(action === "delete"){   
      manageDeleteDeviceDisplay()
    }  
  };

  const manageAddNewDeviceDisplay = () => {
    setAddDevicePopup(!display_Add_Device_Popup);
  };

  const manageEditDeviceDisplay = () => {
    setEditDevicePopup(!display_Edit_Device_Popup);
  };

  const manageDeleteDeviceDisplay = () => {
    setDeleteDevicePopup(!display_Delete_Device_Popup);
  };

  const closeAfterAdding = () => {
    retrieveDeviceList();
    manageAddNewDeviceDisplay();
  };

  const closeAfterEdition = () => {
    retrieveDeviceList();
    manageEditDeviceDisplay();
  };

  const closeAfterDeletion = () => {
    retrieveDeviceList();
    manageDeleteDeviceDisplay();
  };

  let columns;
  if (props.accountInformation.readOnly === true) {
   columns = useMemo(
    () => [
      {
        Header: <FormattedMessage id="device.type" defaultMessage="Device" /> ,
        accessor: "type",
      },
      {
        Header: <FormattedMessage id="device.name" defaultMessage="Serial number" /> ,
        accessor: "sn",
      },
      {
        Header: <FormattedMessage id="device.nickname" defaultMessage="Nickname" /> ,
        accessor: "nickname",
      }
    ],
    []
    );
  }
  else {
   columns = useMemo(
    () => [
      {
        Header: <FormattedMessage id="device.type" defaultMessage="Device" /> ,
        accessor: "type",
      },
      {
        Header: <FormattedMessage id="device.name" defaultMessage="Serial number" /> ,
        accessor: "sn",
      },  
      {
        Header: <FormattedMessage id="device.nickname" defaultMessage="Nickname" /> ,
        accessor: "nickname",
      },                
      {
        Header:  <FormattedMessage id="button.action" defaultMessage="Action" /> ,
        accessor: "actions",
        Cell: (props) => {
          const rowIdx = props.row.id;
          return (
            <div>
              <span onClick={() => editOrDeleteDevice(rowIdx, "edit")}
                data-tooltip="Modifier" >                
                <i className="far fa-edit action mr-2"></i>
              </span>
              <b>&emsp;</b>              
              <span onClick={() => editOrDeleteDevice(rowIdx, "delete")}
                  data-tooltip="Supprimer">
                <i className="fas fa-trash action"></i>
              </span>
            </div>
          );
        },
      },
    ],
    //eslint-disable-next-line
    []
  );
 }


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data: device_list,
  });

  return (
    <div>
      <Row style={{width: '100%', paddingTop:"10px", paddingBottom:'10px'}}>
        <Col sm={8} style = {{width:"50%"}}>
          <Row style={{margin:'auto'}}>
            <input
              type="text"
              className="form-control"
              placeholder="Recherche par numéro série"
              value={searchSerialNb}
              onChange={onChangeSearchSerialNb}
              style = {{width:"auto", maxWidth:"70%"}}
            />
            <button className="btn btn-outline-secondary" onClick={findDeviceBySerialNb} style={{width:"auto", maxWidth:"30%"}}>
              <Icon name='search' size='large' inverted color='black'/>
            </button>
          </Row>
        </Col>
        {(props.role !== "staff" && props.accountInformation.readOnly !== true) ?
        <Col sm={4} style={{ width: "50%", display: "flex", flexDirection: "row", justifyContent: "right"}}>
          <button className="btn btn-sm btn-success" onClick={manageAddNewDeviceDisplay} style={{ heigth: 'auto', width: "100px", fontSize: "0.9em"}}>
            <FormattedMessage id="button.add" defaultMessage="Add" />
          </button>
        </Col>
          :
          null
        }
      </Row>
      <div className="col-md-12 list">
        <table
          className="table table-striped table-bordered"
          {...getTableProps()}
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {display_Add_Device_Popup ? <AddDevice cancelPopup={manageAddNewDeviceDisplay} closeAfterAdd={closeAfterAdding} structure_Id={props.structure_Id}/> : null}
      {display_Edit_Device_Popup ? <Device cancelPopup={manageEditDeviceDisplay} closeAfterEdit={closeAfterEdition} id_device={current_Id_Device} structure_Id={props.structure_Id}/> : null}
      {display_Delete_Device_Popup ? <DeleteObject cancelPopup={manageDeleteDeviceDisplay} closeAfterDelete={closeAfterDeletion} id={current_Id_Device} object_type={"Device"} object_name={current_sn_Device} structure_Id={props.structure_Id} reloadUserAndProfiles={props.reloadUserAndProfiles}/> : null}
    </div>
  );
};

export default withStyles(Constants.styles)(DeviceList);
